import { render, staticRenderFns } from "./ExternalSupplierDetails.vue?vue&type=template&id=1340f96b&scoped=true"
import script from "./ExternalSupplierDetails.vue?vue&type=script&lang=js"
export * from "./ExternalSupplierDetails.vue?vue&type=script&lang=js"
import style0 from "./ExternalSupplierDetails.vue?vue&type=style&index=0&id=1340f96b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1340f96b",
  null
  
)

export default component.exports